module.exports = __webpack_public_path__ + "assets/img/container-ios2.e6bcafb.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/container-ios2.png
// module id = aCwl
// module chunks = 50